import MessageBanner from 'shared/components/MessageBanner';
import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';
import {isBrowserAndDeviceSupported} from 'shared/utils/browser-detector';

const OutdatedBrowserBanner = () => {
  const {isBrowserSupported, isIOSSupported} = isBrowserAndDeviceSupported();
  if (isBrowserSupported && isIOSSupported) {
    return null;
  }

  return (
    <MessageBanner
      type="info"
      heading={!isIOSSupported ? intlFormatSingleMessage(LOCALIZED_TRANSLATIONS.IOS_HEADER) : undefined}
      subtext={intlFormatSingleMessage(
        !isIOSSupported ? LOCALIZED_TRANSLATIONS.IOS_TEXT : LOCALIZED_TRANSLATIONS.BROWSER_TEXT
      )}
    />
  );
};

export default OutdatedBrowserBanner;

const LOCALIZED_TRANSLATIONS = {
  IOS_HEADER: 'Your iOS is out of date',
  IOS_TEXT:
    'For the best performance and security, please update your iPhone or iPad to the latest version by going to Settings > General > Software Update.',
  BROWSER_TEXT:
    'We recommend using the latest version of Google Chrome, Microsoft Edge, Firefox or Safari for the best customer experience on Amica.com. Internet Explorer (IE) unfortunately no longer maintains our security and web standards.'
};
